import { BreadcrumbProps } from './breadcrumb'
import { CourseStatus, FileStatus, FileType } from '../admin'

export enum CourseContentItemType {
  BLOCK_SEPARATOR = 'block_separator',
  BLOCK = 'block',
  FOLDER = 'folder',
  COURSE_CLASS = 'class',
  FILE = 'file',
  NEW_BLOCK = 'new_block',
  ADD_CONTENT = 'add_content',
}

export type FileProps = {
  fileId?: number
  fileName: string
  status: FileStatus
  type: FileType
  url: string
  platformType: string
}

export type ContentProps = DataWithChildren<ContentProps> & {
  id: number
  contentId?: number
  type: CourseContentItemType
  status: CourseStatus
  title: string
  breadcrumb?: BreadcrumbProps[]
  numberOfCourses?: number
  numberOfFolders?: number
  numberOfFiles?: number
  parentId?: number
  parentData?: ContentProps
  order: number
  isExpanded?: boolean
  file?: FileProps
}

export interface TreeItem<T extends DataWithId> {
  data: T
  depth: number
  order: number
  parents: {
    id: number
    depth: number
  }[]
}

export interface DataWithId {
  id: number
}

export interface DataWithChildren<T> {
  items?: T[]
}
